// app/hooks/useSimpleAutoRefresh.js
import { useEffect, useRef } from "react";

export function useSimpleAutoRefresh(interval) {
  const versionRef = useRef("");

  useEffect(() => {
    if (typeof window === "undefined") return; // SSR guard

    const isLocalhost =
      window.location.hostname.includes("localhost") ||
      window.location.hostname.includes("127.0.0.1") ||
      window.location.hostname.includes("0.0.0.0");

    if (isLocalhost) return;

    const fetchVersion = async () => {
      try {
        const response = await fetch("/meta/version.txt", {
          cache: "no-cache",
          headers: {
            "Cache-Control": "no-cache, no-store, must-revalidate",
            Pragma: "no-cache",
            Expires: "0",
          },
        });

        if (response.status === 200) {
          const versionText = (await response.text()).trim();

          if (versionRef.current && versionRef.current !== versionText) {
            window.location.reload();
          } else {
            versionRef.current = versionText;
          }
        }
      } catch (err) {
        console.error("Version check error:", err);
      }
    };

    fetchVersion();
    const intervalId = setInterval(fetchVersion, interval);

    return () => clearInterval(intervalId);
  }, [interval]);
}
